var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-results-d" },
    [
      _vm.message
        ? _c("div", { staticClass: "search-results-d__message" }, [
            _vm._v("\n    " + _vm._s(_vm.message) + "\n  ")
          ])
        : _vm._l(_vm.list, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "search-results-d__item" },
              [
                _c(
                  "a",
                  {
                    staticClass: "search-results-d__link",
                    class: _vm.getLinkClasses(item),
                    attrs: { href: _vm.jsv },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$emit("select", item)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "search-results-d__caption",
                      domProps: {
                        innerHTML: _vm._s(_vm.getSearchCaption(item.caption))
                      }
                    }),
                    _vm._v(" "),
                    item.count
                      ? _c("span", { staticClass: "search-results-d__count" }, [
                          _vm._v(
                            "\n          " + _vm._s(item.count) + "\n        "
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ]
            )
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }